// Deterministic cache-bust: compares the build version baked into the bundle
// against /version.json served by the deploy. When they differ, the user is
// on a stale HTML/JS combo and we force a hard reload to pick up new chunks.

declare const __APP_VERSION__: string;

const BUILD_VERSION =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";

const CHECK_INTERVAL_MS = 5 * 60 * 1000; // every 5 minutes
const RELOAD_FLAG = "__bv_reloaded_for_version__";

async function fetchDeployedVersion(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
      credentials: "omit",
    });
    if (!res.ok) return null;
    const data = (await res.json()) as { version?: string };
    return data.version ?? null;
  } catch {
    return null;
  }
}

function hardReload() {
  // Prevent reload loops if version.json is misconfigured.
  if (sessionStorage.getItem(RELOAD_FLAG) === BUILD_VERSION) return;
  sessionStorage.setItem(RELOAD_FLAG, BUILD_VERSION);

  const url = new URL(window.location.href);
  url.searchParams.set("v", Date.now().toString());
  window.location.replace(url.toString());
}

async function checkOnce() {
  const deployed = await fetchDeployedVersion();
  if (!deployed || deployed === "dev") return;
  if (deployed !== BUILD_VERSION) hardReload();
  else sessionStorage.removeItem(RELOAD_FLAG);
}

export function startVersionCheck() {
  if (typeof window === "undefined") return;
  if (!import.meta.env.PROD) return;

  // Initial check after first paint.
  setTimeout(checkOnce, 3000);

  // Periodic check.
  setInterval(checkOnce, CHECK_INTERVAL_MS);

  // Check when tab regains focus / comes back online.
  window.addEventListener("focus", checkOnce);
  window.addEventListener("online", checkOnce);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkOnce();
  });
}

export const APP_BUILD_VERSION = BUILD_VERSION;
